import { HistoryGraphContainer } from 'pages/NewOverview/styles';
import styled from 'styled-components';
import { Select } from '~/components/NewSelect';
import { CardsContainerLoading } from '../styles';

export const EnergyEfficiencyCardContainer = styled(HistoryGraphContainer)<{ expandedSplit: boolean }>`
  width: ${({ expandedSplit }) => (expandedSplit ? '50%' : '532px')};
  height: 364px;
  display: flex;
  gap: 14px;
  position: relative;

  @media (max-width: 768px) {
    height: 430px;
  }
`;

export const EnergyEfficiencyCardLoading = styled(CardsContainerLoading)<{ expandedSplit: boolean }>`
  width: ${({ expandedSplit }) => (expandedSplit ? '50%' : '532px')};
  .skeleton-span, .skeleton-container-span {
    width: ${({ expandedSplit }) => (expandedSplit ? '100%' : '532px')};
  }

  @media (max-width: 768px) {
    width: 100%;
    .skeleton-span, .skeleton-container-span {
      width: 100%;
    }
  }
`;

export const RankingSelect = styled(Select)`
  top: 10px;
  right: 20px;
  position: absolute;
  width: 146px;
  height: 44px;

  & > div:nth-child(1) {
    height: 44px;
    min-height: 44px;
  }

  @media (max-width: 768px) {
    position: relative;
    top: auto;
    right: auto;
    align-self: flex-start;
    margin-bottom: 16px;
  }
`;
